import React, {Fragment} from 'react';
import {useQuery} from '@apollo/client';
import {CUSTOMER_NOTIFICATION_DATA} from './queries.js';
import {getCustomerNotificationComponent} from './customer-notification-components-dictionary';

export const CustomerNotification = ({
    locale,
    deviceType,
    notificationLocation,
    funnelLocation,
    duaid,
    siteId,
}) => {
    const {data, error} = useQuery(CUSTOMER_NOTIFICATION_DATA, {
        variables: {
            context: {
                identity: {
                    duaid,
                },
                locale,
                siteId,
                device: {type: deviceType},
            },
            notificationLocation,
            lineOfBusiness: 'LODGING',
            pageLocation: funnelLocation,
        },
        fetchPolicy: 'network-only',
    });

    if (error) {
        console.log('Error in response', error);
    }
    if (data) {
        console.log('data');
        const notification = data.notification.inlineNotification;
        const notificationType = notification.type;
        if (notification) {
            const NotificationComponent = getCustomerNotificationComponent(
                notificationLocation,
                notificationType
            );
            return NotificationComponent ? (
                <NotificationComponent
                    notification={notification}
                    page={funnelLocation}
                />
            ) : (
                <Fragment />
            );
        }
    }
    return <Fragment />;
};
